module.exports = __webpack_public_path__ + "img/follower-robots.c6f95115.png";